import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import Container from '~shared/Container'
import Gallery, { slideIndex } from '~shared/Gallery'
import Link from '~shared/Link'
import urls from '~utils/urls'
import Topic from '~shared/Topic'
import ButtonWrapper from '~shared/ButtonWrapper'
import CaseStudy from '~shared/CaseStudy'
import PrestyledSliderNav from '~shared/SliderNav'
import Display from '~shared/Display'
import Spacer from '~shared/Spacer'
import DangerousHtml from '~shared/DangerousHtml'
import useTranslation from '~utils/useTranslation'
import SocialImageTracey from '~shared/../CaseStudies/Tracey/SocialImage'
import SocialImageSwash from '~shared/../CaseStudies/Swash/SocialImage'
import SocialImageMachineWitness from '~shared/../CaseStudies/MachineWitness/SocialImage'
import SocialImagePaveMotors from '~shared/../CaseStudies/PaveMotors/SocialImage'

const Content = styled.div`
    margin-top: 48px;

    @media (min-width: ${DESKTOP}px) {
        margin-top: 112px;
    }
`

const ContentInner = styled.div`
    @media (min-width: ${DESKTOP}px) {
        padding: 0 48px;
    }
`

const Studies = styled.div`
    position: relative;

    ${Button} {
        margin-top: 2.5rem;
    }
`

const SlideContainer = styled(Container)`
    @media (max-width: ${TABLET - 1}px) {
        padding: 0;
    }
`

const SliderNav = styled(PrestyledSliderNav)`
    margin: 0 auto;
`

const UnstyledCaseStudies = (props) => {
    const [slide, setSlide] = useState(0)

    const index = slideIndex(slide, 4)

    const { t } = useTranslation()

    return (
        <div {...props}>
            <SlideContainer>
                <Gallery
                    slide={slide}
                    onChange={setSlide}
                >
                    <a href={index !== 0 ? undefined : urls.caseStudies.paveMotors}>
                        <Gallery.Item as="div" disabled={index !== 0}>
                            <SocialImagePaveMotors />
                        </Gallery.Item>
                    </a>
                    <a href={index !== 1 ? undefined : urls.caseStudies.swash}>
                        <Gallery.Item as="div" disabled={index !== 1}>
                            <SocialImageSwash />
                        </Gallery.Item>
                    </a>
                    <a href={index !== 2 ? undefined : urls.caseStudies.tracey}>
                        <Gallery.Item as="div" disabled={index !== 2}>
                            <SocialImageTracey />
                        </Gallery.Item>
                    </a>
                    <a href={index !== 3 ? undefined : urls.caseStudies.machineWitness}>
                        <Gallery.Item as="div" disabled={index !== 3}>
                            <SocialImageMachineWitness />
                        </Gallery.Item>
                    </a>
                </Gallery>
            </SlideContainer>
            <Container>
                <Content>
                    <ContentInner>
                        <Studies>
                            <CaseStudy
                                name="Pave Motors"
                                active={index === 0}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.paveMotors.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <Button
                                        tag={Link}
                                        to={urls.caseStudies.paveMotors}
                                        kind="secondaryLight"
                                        size="big"
                                        outline
                                        noDecoration
                                        noHover
                                    >
                                        {t('caseStudy.readMore')}
                                    </Button>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Swash"
                                active={index === 1}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.swash.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <Button
                                        tag={Link}
                                        to={urls.caseStudies.swash}
                                        kind="secondaryLight"
                                        size="big"
                                        outline
                                        noDecoration
                                        noHover
                                    >
                                        {t('caseStudy.readMore')}
                                    </Button>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Tracey"
                                active={index === 2}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.tracey.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <Button
                                        tag={Link}
                                        to={urls.caseStudies.tracey}
                                        kind="secondaryLight"
                                        size="big"
                                        outline
                                        noDecoration
                                        noHover
                                    >
                                        {t('caseStudy.readMore')}
                                    </Button>
                                </ButtonWrapper>
                            </CaseStudy>
                            <CaseStudy
                                name="Machine Witness"
                                active={index === 3}
                            >
                                <DangerousHtml tag={Topic.Paragraph} $appear>
                                    {t('caseStudy.machineWitness.desc')}
                                </DangerousHtml>
                                <ButtonWrapper>
                                    <Button
                                        tag={Link}
                                        to={urls.caseStudies.machineWitness}
                                        kind="secondaryLight"
                                        size="big"
                                        outline
                                    >
                                        {t('caseStudy.readMore')}
                                    </Button>
                                </ButtonWrapper>
                            </CaseStudy>
                        </Studies>
                    </ContentInner>
                </Content>
                <Display as={Spacer} mobile="block" tablet="none" head="4.5rem">
                    <SliderNav
                        current={index}
                        size={4}
                        onChange={setSlide}
                        theme={SliderNav.WhiteTheme}
                    />
                </Display>
            </Container>
        </div>
    )
}

const CaseStudies = styled(UnstyledCaseStudies)`
    ${Content},
    ${Gallery.SlideContainer} {
        padding: 0;

        @media (min-width: ${TABLET}px) {
            padding: 0 24px;
        }

        @media (min-width: ${DESKTOP}px) {
            padding: 0 48px;
        }
    }
`

export default CaseStudies
